<template>
  <div>
    <ShortCut></ShortCut>
    <LogoHome></LogoHome>
    <Navigation></Navigation>

<!--    <LogoGroup v-on:getGoodsList="updateGoodsList"></LogoGroup>-->


    <div class="group-logo-class">
      <!--      <img src="../image/logo2.png" class="img-logo-class" @click="toHome()"/>-->
      <div class="group-class">
        <div class="child-group-class">
          <div class="child-group-title-class">
<!--            <span>-->
            一级分类：
<!--            </span>-->
          </div>
          <div class="child-title-group-class" v-for="(item,index) in oneGroup" :key="index">
            <a @click="getTwoChildGroup(item.child,item.catCode)" @mouseover="getTwoChildGroup(item.child)" class="a-child-title-group-class">{{item.catName}}</a>
            <a class="no-cursor-a-class">|</a>
          </div>
        </div>
        <hr style="border:1px dashed #B0B0B0;height:0px;">
        <div class="child-group-class">
          <div class="child-group-title-class">
<!--            <span>-->
            二级分类：
<!--            </span>-->
          </div>
          <div class="child-title-group-class" v-for="(item,index) in twoGroup" :key="index">
            <a @click="getThreeChildGroup(item.child,item.catCode)" @mouseover="getThreeChildGroup(item.child)" class="a-child-title-group-class">{{item.catName}}</a>
            <a class="no-cursor-a-class">|</a>
          </div>
        </div>
        <hr style="border:1px dashed #B0B0B0;height:0px">
        <div class="child-group-class">
          <div class="child-group-title-class">
<!--            <span>-->
            三级分类：
<!--            </span>-->
          </div>

          <div class="child-title-group-class" v-for="(item,index) in threeGroup" :key="index">
            <a @click="getGoodsList(item.catCode)" class="a-child-title-group-class">{{item.catName}}</a>
            <a class="no-cursor-a-class">|</a>
          </div>
        </div>
      </div>

    </div>

<!--    <HeaderTop>-->
<!--    </HeaderTop>-->
    <div id="shopcar">
      <div id="content">
<!--        <div class="header">-->
<!--          <img src="../image/logo2.png" class="header_logo" />-->
<!--          <span>传统下单</span>-->
<!--        </div>-->
        <div class="cont_title">
          <span>检索条件</span>
          <el-form ref="form" :model="form" label-width="80px" class="form-class">
          <el-row :gutter="20">
            <el-col :span="8"><div class="grid-content bg-purple">
              <el-form-item label="助记码">
                <el-input v-model="form.zjm"></el-input>
              </el-form-item>
            </div></el-col>
            <el-col :span="8"><div class="grid-content bg-purple">
              <el-form-item label="产品名称">
                <el-input v-model="form.goodsName"></el-input>
              </el-form-item>
            </div></el-col>
            <el-col :span="8"><div class="grid-content bg-purple">
              <el-form-item label="厂家">
                <el-input v-model="form.goodsMan"></el-input>
              </el-form-item>
            </div></el-col>
            <el-col :span="8"><div class="grid-content bg-purple">
              <el-form-item label="包装量">
                <el-input v-model="form.qty"></el-input>
              </el-form-item>
            </div></el-col>
            <el-col :span="8"><div class="grid-content bg-purple">
              <el-form-item label="批准文号">
                <el-input v-model="form.approvalNo"></el-input>
              </el-form-item>
            </div></el-col>
            <el-col :span="4"><div class="grid-content bg-purple">
              <el-button icon="el-icon-refresh-left" @click="resetForm">重置</el-button>
            </div></el-col>
            <el-col :span="4"><div class="grid-content bg-purple">
              <el-button icon="el-icon-search" @click="getGoodsList('')">搜索</el-button>
            </div></el-col>
          </el-row>
          </el-form>
        </div>


        <div class="tableClass">
          <el-table ref="multipleTable" :data="formData.tableData.slice(
              (currpage - 1) * pagesize,
              currpage * pagesize
            )" tooltip-effect="dark" style="width: 100%" border
          >
            <el-table-column  label="商品编号" show-overflow-tooltip width="80px" prop="GOODSCODE">
            </el-table-column>
            <el-table-column  label="商品名称" show-overflow-tooltip width="200px" prop="GOODSNAME">
            </el-table-column>
            <el-table-column  label="商品规格" show-overflow-tooltip width="150px" prop="GOODSSPEC">
            </el-table-column>
            <el-table-column  label="生产厂家" show-overflow-tooltip prop="MANUFACTURER" >
            </el-table-column>
            <el-table-column  label="批号" show-overflow-tooltip prop="BATCHCODE" >
            </el-table-column>
            <el-table-column  label="生产日期" show-overflow-tooltip prop="PRODUCEDATE" >
            </el-table-column>
            <el-table-column  label="有效期至" show-overflow-tooltip prop="VALDATE" >
            </el-table-column>
            <el-table-column  label="可销数量" show-overflow-tooltip prop="PLACENUM" >
            </el-table-column>
            <el-table-column  label="数量" show-overflow-tooltip width="140px">
              <template slot-scope="scopeNum" >
                <el-input-number v-model="scopeNum.row.NUM"  :min="1" :max="999999" label="请输入数量" size="small"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column  label="含税价" show-overflow-tooltip width="140px" prop="TAXPRICE">
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleAdd(scope.$index, scope.row)"
                >添加</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-divider></el-divider>
        </div>
        <el-pagination background
                       layout="prev, pager, next, sizes, total, jumper"
                       :page-sizes="[5, 10, 15, 20]"
        :page-size="pagesize"
        :total="formData.tableData.length"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>



</template>

<script>
import ShortCut from '../component/ShortCut'
import Notice from "../component/Notice";

import Navigation from "../component/Navigation";
import LogoGroup from "../component/LogoGroup";
import LogoHome from "../component/LogoHome";
import {billOrders, getBillNo, saveBill, saveTable, billCheckOrders, getClass} from '../../api';
export default {
  components:{
    ShortCut,
    Navigation,
    LogoGroup,
    LogoHome
  },
  data(){
    return{
      form:{
        zjm:"",
        goodsName:"",
        goodsMan:"",
        qty:"",
        approvalNo:""
      },
      msg: 8888,
      list: [],
      pagesize: 10,
      currpage: 1,
      formData: {
        tableData: [],
      },
      billDetail:[],
      userInfo:{},
      oneGroup:[],
      twoGroup:[],
      threeGroup:[],
    }
  },
  methods:{
    getGoodsList(val) {
        this.formData.tableData=[];
        console.log("----'"+val+"'----");
        billOrders({
          M_STAFFID: this.userInfo.STAFFID,
          M_ORGID: this.userInfo.OWNERID,
          M_ENTID: this.userInfo.ENTID,
          M_ACTION: 47,
          M_PAGECOUNT: 1000000,
          M_PAGE: 1,
          M_CLIENTID: this.userInfo.BUSINESSID,
          M_LOGOGRAM: this.form.zjm,
          M_GOODSNAME: this.form.goodsName,
          M_GOODSMAN: this.form.goodsMan,
          M_APPROVALNO: this.form.approvalNo,
          M_QTY: this.form.qty == "" ? 0 : this.form.qty,
          M_COALL:"%%",
          M_CLASS:val
        }).then(res=>{
          // console.log(res);
          //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
          // 请求返回数据
          let dataset = res.data.data.DATASET;
          if(dataset.length==0){
            this.$message.error('获取商品失败，请联系管理员！');
            return false;
          }else{
            this.formData.tableData=dataset;
            // console.log(dataset[0]);
            // sessionStorage.setItem("USERINFO",dataset[0]);
            // this.$router.push('/home');
          }
        }).catch(err=>{
          // 请求失败执行
          // console.log(err)
        });
    },
    handleCurrentChange(cpage) {
      this.currpage = cpage;
    },
    handleSizeChange(psize) {
      this.pagesize = psize;
    },
    handleSelectionChange(val) {
      // console.log(val)
    },
    handleAdd(index,row){
      // this.billDetail = sessionStorage.getItem("billDetail");
      const that = this;
      billOrders({
        M_BUSINESSID: that.userInfo.BUSINESSID,
        M_GOODSID:row.GOODSID,
        M_ORGID:row.OWNERID,
        M_ACTION:101,
      }).then(res=>{
        console.log(res);
        if(res.data.code==200){
          let dataset = res.data.data.DATASET;
          console.log(dataset);
          if(dataset.length!=0){
            let retJSON = dataset[0];
            if(retJSON.ISHOLD=='true'){
              that.$message.error(retJSON.CHKINFO);
              return false;
            }else{
              if(row.NUM>0) {
                let detail = sessionStorage.getItem("billDetail");
                if (detail != null) {
                  that.billDetail = JSON.parse(detail);
                }
                let goods = {};
                goods.GoodsCode = row.GOODSCODE;
                goods.GoodsName = row.GOODSNAME;
                goods.GoodsSpec = row.GOODSSPEC;
                goods.GoodsMan = row.MANUFACTURER;
                goods.GoodsTaxPrice = row.TAXPRICE;
                goods.GoodsNum = row.NUM;
                goods.Num = row.NUM;
                goods.BaseNum = row.NUM;
                goods.TaxAmount = Math.round(row.TAXPRICE * row.NUM*100)/100;
                goods.Amount = row.PRICE*row.NUM;
                goods.Tax = Math.round(row.TAXPRICE * row.NUM*100)/100-Math.round(row.PRICE*row.NUM*100)/100;
                goods.ExecNum = 0;
                goods.GoodsTaxAmount = Math.round(row.TAXPRICE * row.NUM*100)/100;
                goods.BatchCode = row.BATCHCODE;
                goods.ProduceDate = row.PRODUCEDATE;
                goods.ValDate = row.VALDATE;
                goods.AngleId = row.ANGLEID;
                goods.PlaceNum = row.PLACENUM;
                goods.Retailt = 0;
                goods.OldPrice = 0;
                goods.NewPrice = 0;
                goods.OldTaxPrice = 0;
                goods.NewTaxPrice =0;
                goods.SoldNum=0;
                goods.NotSoldNum = 0;
                goods.OutCost = 0;
                goods.RfBillNo = 0;
                goods.RfBillSn = 0;
                goods.ReBillNo=0;
                goods.ReBillSn=0;
                goods.RfBillCode = "";
                goods.ReBillCode = "";
                goods.RfRuleId = "";
                goods.ReRuleId = "";
                goods.GRpNo=0;
                goods.CheckCost=0;
                goods.ActProfit = 0;
                goods.ActPrice = 0;
                goods.ActTaxPrice=0;
                goods.ActAmount = 0;
                goods.OldActPrice = 0;
                goods.NewActPrice = 0 ;
                goods.OldActTaxPrice = 0;
                goods.NewActTaxPrice = 0;
                goods.OutActCost = 0;
                goods.SaleTaxP = row.TAXPRICE;
                goods.IS_HD = "N";
                goods.HDBILLNO=0;
                goods.HDBillSn=0;
                goods.PTTaxPrice = row.TAXPRICE;
                goods.YSBBillNo=0;
                goods.YSBBillSn=0;
                goods.BillNo = 0;
                goods.EntId = that.userInfo.ENTID;
                goods.GoodsId = row.GOODSID;
                goods.OwnerId = row.OWNERID;
                goods.PackId = row.PACKID;
                goods.Meas = row.MEAS;
                goods.Rate = row.RATE;
                goods.WhOrgId = row.WHORGID;
                goods.IsDone = "N";
                goods.Unit = row.UNIT;
                goods.LocatId = row.LOCATID;
                goods.BillSN = index+1;
                goods.BillSort = index+1;
                goods.DedRate = 100;
                goods.Profit = 0;
                goods.Retailp = 0;
                goods.IsFree = "N";
                goods.BaseTaxPrice = row.TAXPRICE;
                goods.TaxPrice = row.TAXPRICE;
                goods.Price = row.PRICE;
                goods.BasePrice = row.PRICE;
                goods.isfree="N";
                goods.is_wlqr="N";
                goods.is_hwqr="N";
                goods.is_kfqr="N";
                goods.ischeck="N";
                goods.WhId = row.WHID;
                goods.WhOrgId = row.WHORGID;
                goods.kfqrshl=0;
                goods.kfqxshl=0;
                goods.WLQRSHL = 0;
                goods.WLQXSHL = 0;
                goods.WLQRJE = 0;
                goods.WLQRSHE = 0;
                goods.WLQRHSJE= 0;
                goods.KFQRJE= 0;
                goods.KFQRSHE=0;
                goods.KFQRHSJE = 0;
                goods.HWQRSHL=0;
                goods.HWQXSHL=0;
                goods.YHSSHL= 0;
                goods.YHESJE=0;
                goods.SOUBILLNO=0;
                goods.SOUBILLSN=0;
                goods.WLQRJG=0;
                goods.WLQRHSJ=0;
                goods.COST=0;
                goods.ISRETDONE='N';
                goods.REFUSEDNUM=0;
                goods.ISREFUSED="N";
                goods.ISPREFERENTIAL = row.ISPREFERENTIAL;
                goods.PREFERENTIALRATES = row.PREFERENTIALRATES;
                goods.ISEPHE = row.ISEPHE;
                goods.GoodsGroup = row.GOODSGROUP;
                if(that.billDetail.length>0){
                  let goodsGroup = that.billDetail[0].GoodsGroup;
                  let goodsId = that.billDetail[0].GoodsId;
                  if(goods.GoodsGroup != goodsGroup && goodsId !="" && goodsId != null){
                    that.$message.error("当前商品与已存在商品分组互斥，请检查！");
                    return false;
                  }
                }
                that.billDetail.push(goods);
                sessionStorage.setItem('billDetail', JSON.stringify(that.billDetail));
                that.$message.success("添加成功！");
              }else{
                that.$message.error('请填写商品数量！');
              }
            }
          }
        }else{
          that.$message.error(res.msg);
          return false;
        }
      }).catch(err=>{
        // 请求失败执行
        console.log(err)
      });

      // this.afterSelGoods(row).then(res=>{
      //   if(res){
      //     if(row.NUM>0) {
      //       let detail = sessionStorage.getItem("billDetail");
      //       if (detail != null) {
      //         this.billDetail = JSON.parse(detail);
      //       }
      //       let goods = {};
      //       goods.GoodsCode = row.GOODSCODE;
      //       goods.GoodsName = row.GOODSNAME;
      //       goods.GoodsSpec = row.GOODSSPEC;
      //       goods.GoodsMan = row.MANUFACTURER;
      //       goods.GoodsTaxPrice = row.TAXPRICE;
      //       goods.GoodsNum = row.NUM;
      //       goods.Num = row.NUM;
      //       goods.BaseNum = row.NUM;
      //       goods.TaxAmount = Math.round(row.TAXPRICE * row.NUM*100)/100;
      //       goods.Amount = row.PRICE*row.NUM;
      //       goods.Tax = Math.round(row.TAXPRICE * row.NUM*100)/100-Math.round(row.PRICE*row.NUM*100)/100;
      //       goods.ExecNum = 0;
      //       goods.GoodsTaxAmount = Math.round(row.TAXPRICE * row.NUM*100)/100;
      //       goods.BatchCode = row.BATCHCODE;
      //       goods.ProduceDate = row.PRODUCEDATE;
      //       goods.ValDate = row.VALDATE;
      //       goods.AngleId = row.ANGLEID;
      //       goods.PlaceNum = row.PLACENUM;
      //       goods.Retailt = 0;
      //       goods.OldPrice = 0;
      //       goods.NewPrice = 0;
      //       goods.OldTaxPrice = 0;
      //       goods.NewTaxPrice =0;
      //       goods.SoldNum=0;
      //       goods.NotSoldNum = 0;
      //       goods.OutCost = 0;
      //       goods.RfBillNo = 0;
      //       goods.RfBillSn = 0;
      //       goods.ReBillNo=0;
      //       goods.ReBillSn=0;
      //       goods.RfBillCode = "";
      //       goods.ReBillCode = "";
      //       goods.RfRuleId = "";
      //       goods.ReRuleId = "";
      //       goods.GRpNo=0;
      //       goods.CheckCost=0;
      //       goods.ActProfit = 0;
      //       goods.ActPrice = 0;
      //       goods.ActTaxPrice=0;
      //       goods.ActAmount = 0;
      //       goods.OldActPrice = 0;
      //       goods.NewActPrice = 0 ;
      //       goods.OldActTaxPrice = 0;
      //       goods.NewActTaxPrice = 0;
      //       goods.OutActCost = 0;
      //       goods.SaleTaxP = row.TAXPRICE;
      //       goods.IS_HD = "N";
      //       goods.HDBILLNO=0;
      //       goods.HDBillSn=0;
      //       goods.PTTaxPrice = row.TAXPRICE;
      //       goods.YSBBillNo=0;
      //       goods.YSBBillSn=0;
      //       goods.BillNo = 0;
      //       goods.EntId = this.userInfo.ENTID;
      //       goods.GoodsId = row.GOODSID;
      //       goods.OwnerId = row.OWNERID;
      //       goods.PackId = row.PACKID;
      //       goods.Meas = row.MEAS;
      //       goods.Rate = row.RATE;
      //       goods.WhOrgId = row.WHORGID;
      //       goods.IsDone = "N";
      //       goods.Unit = row.UNIT;
      //       goods.LocatId = row.LOCATID;
      //       goods.BillSN = index+1;
      //       goods.BillSort = index+1;
      //       goods.DedRate = 100;
      //       goods.Profit = 0;
      //       goods.Retailp = 0;
      //       goods.IsFree = "N";
      //       goods.BaseTaxPrice = row.TAXPRICE;
      //       goods.TaxPrice = row.TAXPRICE;
      //       goods.Price = row.PRICE;
      //       goods.BasePrice = row.PRICE;
      //       goods.isfree="N";
      //       goods.is_wlqr="N";
      //       goods.is_hwqr="N";
      //       goods.is_kfqr="N";
      //       goods.ischeck="N";
      //       goods.WhId = row.WHID;
      //       goods.WhOrgId = row.WHORGID;
      //       goods.kfqrshl=0;
      //       goods.kfqxshl=0;
      //       goods.WLQRSHL = 0;
      //       goods.WLQXSHL = 0;
      //       goods.WLQRJE = 0;
      //       goods.WLQRSHE = 0;
      //       goods.WLQRHSJE= 0;
      //       goods.KFQRJE= 0;
      //       goods.KFQRSHE=0;
      //       goods.KFQRHSJE = 0;
      //       goods.HWQRSHL=0;
      //       goods.HWQXSHL=0;
      //       goods.YHSSHL= 0;
      //       goods.YHESJE=0;
      //       goods.SOUBILLNO=0;
      //       goods.SOUBILLSN=0;
      //       goods.WLQRJG=0;
      //       goods.WLQRHSJ=0;
      //       goods.COST=0;
      //       goods.ISRETDONE='N';
      //       goods.REFUSEDNUM=0;
      //       goods.ISREFUSED="N";
      //       goods.ISPREFERENTIAL = row.ISPREFERENTIAL;
      //       goods.PREFERENTIALRATES = row.PREFERENTIALRATES;
      //       this.billDetail.push(goods);
      //       sessionStorage.setItem('billDetail', JSON.stringify(this.billDetail));
      //       this.$message.success("添加成功！");
      //     }else{
      //       this.$message.error('请填写商品数量！');
      //     }
      //   }
      // })

    },
    async afterSelGoods(row){
      console.log(this.form.businessId);
      billOrders({
        M_BUSINESSID: this.userInfo.BUSINESSID,
        M_GOODSID:row.GOODSID,
        M_ORGID:row.OWNERID,
        M_ACTION:101,
      }).then(res=>{
        console.log(res);
        if(res.data.code==200){
          let dataset = res.data.data.DATASET;
          console.log(dataset);
          if(dataset.length!=0){
            let retJSON = dataset[0];
            if(retJSON.ISHOLD=='true'){
              this.$message.error(retJSON.CHKINFO);
              return false;
            }else{
              return true;
            }
          }
        }else{
          this.$message.error(res.msg);
          return false;
        }
      }).catch(err=>{
        // 请求失败执行
        console.log(err)
      });
    },
    updateGoodsList(e){
      this.formData.tableData = e;
    },
    getTwoChildGroup(child,val){
      this.twoGroup=child;
      if(typeof(val) == "undefined" || val == null ) {
        this.threeGroup=[];
      }else{
        this.getGoodsList(val);
      }
    },
    getThreeChildGroup(child,val){
      this.threeGroup=child;
      if(typeof(val) == "undefined" || val == null ) {

      }else{
        console.log(val);
        this.getGoodsList(val);
      }
    },
    getClassList(){
      getClass({
      }).then(res=>{
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data;
        if(dataset.length==0){
          this.$message.error('获取商品分类列表失败');
          return false;
        }else{
          this.oneGroup = dataset;
          sessionStorage.setItem("CLASSLIST",JSON.stringify(dataset));
        }
      }).catch(err=>{
        // 请求失败执行
        console.log(err)
      })
    },
    initForm(){
      this.userInfo = JSON.parse(sessionStorage.getItem("USERINFO"));
      this.form.orgName = this.userInfo.OWNERNAME;
      this.form.staffName = this.userInfo.STAFFNAME;
    },
    resetForm(){
      this.form.zjm="";
      this.form.goodsName="";
      this.form.goodsMan="";
      this.form.qty="";
      this.form.approvalNo="";
    }
  },
  mounted() {

    this.initForm();
    this.getClassList();
    // this.getGoodsList("");
  }
}
</script>

<style>
.group-logo-class{
  height: 145px;
  line-height: 115px;
  display: flex;
  background-color: #f2f2f2;
}

.group-class{
  all:initial;
  margin-top: 10px;
  margin-left: 10%;
  font-size: 15px;
  color: #666666;
  width: 80%;
}
.child-group-class{
  display: flex;
  flex-wrap: wrap;
}
.child-group-class>span{
  pointer-events: none;
}

.child-group-title-class>span{
  pointer-events: none;

}

.child-title-group-class{
  padding-left: 4px;
  padding-right: 4px;
}
.a-child-title-group-class{
  cursor:pointer;
}
.a-child-title-group-class:hover{
  color: #d24f48;
  text-decoration: underline;
}
.no-cursor-a-class{
  color: #999;
  padding-left: 1px;
  /*padding-right: 1px;*/
  pointer-events: none;
}
</style>

<style scoped>

/deep/ #content>.header{
  width: 100%;
  height: 90px;
  margin-top: 10px;
  position: relative;
  margin-left: 10%;
  display: flex;
}
/deep/ .header>img{
  width: 80px;
  height: 80px;
  /*border: 1px solid gray;*/
  /*border-radius: 50%;*/
  cursor: pointer;
}
/deep/ .header>span{
  display: inline-block;
  font-size: 25px;
  height: 35px;
  font-weight: 700;
  position: absolute;
  top: 30%;
  margin-left: 100px;
  cursor: pointer;
}
/deep/ #content>.cont_title{
  margin: 10px auto;
  width: 80%;
  height: 35px;
  border-bottom: 2px solid #e6e6e6;
}
/deep/ .cont_title>span{
  display: inline-block;
  font-weight: 700;
  font-size: 17px;
  height: 100%;
  width: 100px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  color: #f40;
  border-bottom: 2px solid #f40;
  display: flex;
}
/deep/ .cont_title>label{
  /*display: inline-block;*/
  font-weight: 700;
  font-size: 17px;
  height: 100%;
  width: 100px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  color: #f40;
  border-bottom: 2px solid #f40;
  display: flex;
}
/deep/ .form-class{
  margin-top: 1%;
}
/deep/ .cont_title_sel{
  margin: 10px auto;
  /*margin-left: 5%;*/
  width: 80%;
  height: 100px;
  border-bottom: 2px solid #e6e6e6;
}
/deep/ .tableClass{
  width: 80%;
  margin-left: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/order/placeOrders.vue